import { CompanyCustomer, FetchGetCompanyCustomersParams } from 'types/contacts';
import { fetcher } from 'utils/axios';

//* Company customers
export const fetchGetCompanyCustomers = async (params: FetchGetCompanyCustomersParams) => {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/companyCustomer/getCompanyCustomers',
        {
          data: params,
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
        customers: Array<CompanyCustomer>;
      };
    else return null;
  } catch (error) {
    console.warn('fetchGetCompanyCustomers error: ', error);
    return null;
  }
};
export const fetchCreateUpdateCompanyCustomer = async (params: Partial<CompanyCustomer>) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/companyCustomer/createUpdateCompanyCustomer',
        {
          data: params,
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('fetchCreateUpdateCompanyCustomer error: ', error);
    return null;
  }
};

/** שדה בקטלוג התצוגות — מגיע מהשרת (contact-field.catalog לפי דגל views) */
export type ViewFieldCatalogEntry = {
  key: string;
  label: string;
  type: 'text' | 'number' | 'date' | 'guid' | 'boolean';
  category: string;
  categoryLabel: string;
  dimension: boolean;
  operators: string[];
};

/**
 * קטלוג השדות של מסך התצוגות. עד כה הרשימה הייתה מקובעת ב-CreateCustomView
 * ומסונכרנת ידנית לקטלוג שבשרת — מה שאיפשר כפילויות ושדות שהשרת לא מכיר.
 * מה שנשאר מקומי הוא רק סוג הפקד וערכי האפשרויות (נתוני חברה, לא סכמה).
 */
export async function fetchViewFieldCatalog(): Promise<ViewFieldCatalogEntry[] | null> {
  try {
    // מעטפת web3 סטנדרטית: { apiVer, success, data, correlationId }
    const res = (await fetcher('get', '/api/services/viewFieldCatalog', 'servernode')) as {
      success?: boolean;
      data?: { fields?: ViewFieldCatalogEntry[] };
    } | null;
    if (!res?.success) return null;
    const fields = res.data?.fields;
    return Array.isArray(fields) && fields.length > 0 ? fields : null;
  } catch (error) {
    console.warn('[contacts] fetchViewFieldCatalog failed', error);
    return null;
  }
}
